<template>
  <div class="c-aed-aedData">
    <div
      class="o-heading o-heading--bold o-heading--size-3 o-heading--section o-heading--border"
    >
      {{ name }}
    </div>
    <div
      class="o-grid o-grid--direction-row o-grid--gutter-tiny o-grid--align-items-center o-field"
    >
      <div class="o-grid__group">
        <div class="o-grid__item o-grid__item--6">
          <span
            class="o-label"
            :title="translationsAvailability.availability || ''"
            >{{ translationsAvailability.availability || "" }}</span
          >
        </div>
        <div class="o-grid__item o-grid__item--6">
          <CallCenterAEDeditableInput
            section="availability"
            name="availability"
            :canEdit="false"
            :value="initialAvailability.name || ''"
          ></CallCenterAEDeditableInput>
        </div>
      </div>
    </div>
    <div
      class="o-grid o-grid--direction-row o-grid--gutter-tiny o-grid--align-items-center o-field"
    >
      <div class="o-grid__group">
        <div class="o-grid__item o-grid__item--6">
          <span class="o-label" :title="translationsAedData.id || ''">{{
            translationsAedData.id || ""
          }}</span>
        </div>
        <div class="o-grid__item o-grid__item--6">
          <CallCenterAEDeditableInput
            :section="section"
            name="id"
            :canEdit="false"
            :value="$store.state.aed.all.id || ''"
          ></CallCenterAEDeditableInput>
        </div>
      </div>
    </div>
    <div
      class="o-grid o-grid--direction-row o-grid--gutter-tiny o-grid--align-items-center o-field"
    >
      <div class="o-grid__group">
        <div class="o-grid__item o-grid__item--6">
          <span
            class="o-label"
            :title="translationsAedData.serialNumber || ''"
            >{{ translationsAedData.serialNumber || "" }}</span
          >
        </div>
        <div class="o-grid__item o-grid__item--6">
          <CallCenterAEDeditableInput
            :section="section"
            name="serialNumber"
            :value="(aedData && aedData.serialNumber) || ''"
          ></CallCenterAEDeditableInput>
        </div>
      </div>
    </div>
    <div
      class="o-grid o-grid--direction-row o-grid--gutter-tiny o-grid--align-items-center o-field"
    >
      <div class="o-grid__group">
        <div class="o-grid__item o-grid__item--6">
          <span
            class="o-label"
            :title="translationsAedData.manufacturerName || ''"
            >{{ translationsAedData.manufacturerName || "" }}</span
          >
        </div>
        <div class="o-grid__item o-grid__item--6">
          <CallCenterAEDeditableDropdown
            :section="section"
            submit-name="manufacturerName"
            mutable-name="name"
            :canSubmit="false"
            :initialValue="
              selectedManufacturer || translationsCustom.unavailiable
            "
            :options="availiableManufacturers"
            :edit-state="editingModel"
            :canCancel="false"
            @valueChange="setSelectedManufacturer($event)"
            :showAttentionIcon="true"
          ></CallCenterAEDeditableDropdown>
        </div>
      </div>
    </div>
    <div
      class="o-grid o-grid--direction-row o-grid--gutter-tiny o-grid--align-items-center o-field"
    >
      <div class="o-grid__group">
        <div class="o-grid__item o-grid__item--6">
          <span class="o-label" :title="translationsAedData.modelName || ''">{{
            translationsAedData.modelName || ""
          }}</span>
        </div>
        <div class="o-grid__item o-grid__item--6">
          <CallCenterAEDeditableDropdown
            :section="section"
            submit-name="model"
            mutable-name="id"
            :edit-state="editingModel"
            :initialValue="
              selectedModel || translationsCustom.noOptionsAvailable
            "
            :canSubmit="
              selectedManufacturer && selectedManufacturer.models ? true : false
            "
            :options="(selectedManufacturer && selectableModels) || []"
            @valueReset="resetManufacturer()"
            @valueSave="editingModel = false"
            :showAttentionIcon="true"
          ></CallCenterAEDeditableDropdown>
        </div>
      </div>
    </div>
    <div
      class="o-grid o-grid--direction-row o-grid--gutter-tiny o-grid--align-items-center o-field"
    >
      <div class="o-grid__group">
        <div class="o-grid__item o-grid__item--6">
          <span
            class="o-label"
            :title="translationsAedData.electrodesExpiration || ''"
            >{{ translationsAedData.electrodesExpiration || "" }}</span
          >
        </div>
        <div class="o-grid__item o-grid__item--6">
          <CallCenterAEDeditableDate
            :section="section"
            name="electrodesExpiration"
            :initialValue="(aedData && aedData.electrodesExpiration) || ''"
            :disabledDates="{
              to: minimumSelectableDay
            }"
          ></CallCenterAEDeditableDate>
        </div>
      </div>
    </div>
    <div
      class="o-grid o-grid--direction-row o-grid--gutter-tiny o-grid--align-items-center o-field"
    >
      <div class="o-grid__group">
        <div class="o-grid__item o-grid__item--6">
          <span
            class="o-label"
            :title="translationsAedData.donatedByTrygFonden || ''"
            >{{ translationsAedData.donatedByTrygFonden || "" }}</span
          >
        </div>
        <div class="o-grid__item o-grid__item--6">
          <CallCenterAEDeditableDropdown
            :section="section"
            submit-name="hasBeenDonated"
            mutable-name="value"
            :initialValue="
              aedData.hasBeenDonated
                ? translationsCustom.yes
                : translationsCustom.no
            "
            :options="donatedOptions"
          ></CallCenterAEDeditableDropdown>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "c-aed-aedData",
  data() {
    return {
      section: "aedData",
      name: "Hjertestarter",
      selectedManufacturer: {},
      selectedModel: {},
      editingModel: false
    };
  },
  computed: {
    ...mapState("translations", {
      translationsAedData: "aedData",
      translationsAvailabilityFull: "availability",
      translationsCustom: "custom"
    }),
    translationsAvailability() {
      return this.translationsAvailabilityFull.availability;
    },
    ...mapGetters("aed", ["aedData", "availability", "minimumSelectableDay"]),
    ...mapGetters("manufacturers", {
      availiableManufacturers: "availiableManufacturers",
      manufacturers: "manufacturers"
    }),
    selectableModels() {
      return this.selectedManufacturer.models.filter(
        model => model.isSelectable
      );
    },
    availabilityOptions() {
      const availabilityOptions = [
        {
          name: this.translationsAvailability.availabilityTypes[0] || "",
          value: "Always"
        },
        {
          name: this.translationsAvailability.availabilityTypes[1] || "",
          value: "OpeningHours"
        },
        {
          name: this.translationsAvailability.availabilityTypes[2] || "",
          value: "BehindLock"
        }
      ];
      return availabilityOptions;
    },
    initialAvailability() {
      return this.availabilityOptions.find(
        option => option.value === this.availability.availability
      );
    },
    donatedOptions() {
      const donatedOptions = [
        {
          name: this.translationsCustom.yes || "",
          value: true
        },
        {
          name: this.translationsCustom.no || "",
          value: false
        }
      ];
      return donatedOptions;
    }
  },
  methods: {
    setSelectedManufacturer(value) {
      this.selectedManufacturer = value;
      this.editingModel = true;
      this.canCancelModelEdit = false;
    },
    setInitialManufacturer() {
      this.selectedManufacturer =
        this.manufacturers.find(
          manufacturer => manufacturer.id === this.aedData.manufacturer
        ) || this.aedData.manufacturerName;
      this.selectedModel = this.selectedManufacturer
        ? this.selectedManufacturer.models.find(
            model => model.id === this.aedData.model
          ) || this.aedData.modelName
        : this.aedData.modelName;
    },
    resetManufacturer() {
      this.setInitialManufacturer();
      this.editingModel = false;
    }
  },
  created() {
    this.setInitialManufacturer();
  }
};
</script>
<style lang="scss">
.c-aed-aedData {
}
</style>
